import { Command } from 'pos/common';
import * as SalesOrderStore from './SalesOrderStore';
import { Res, Permission, SalesOrderDTO } from 'core/api';
import { Preconditions } from 'core/infrastructure-next';
import { reopenDocument, ReopenDocumentResult } from 'pos/modules/helpers/document-reopening';

declare global {
	interface CommandType {
		reopenSalesOrder: (salesOrder: SalesOrderDTO) => Promise<Result<ReopenDocumentResult>>
	}
}

Command.register('reopenSalesOrder', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_Reopen), Preconditions.ensureIsNotLite), async (salesOrder: SalesOrderDTO): Promise<Result<ReopenDocumentResult>> => {
	return reopenDocument({
		title: Res.Web.REOPEN_SALES_ORDER(),
		canReopen: () => Promise.resolve(true),
		reopen: location => SalesOrderStore.reopen(salesOrder.Id, location),
		reopenInTicket: (location, targetId) => SalesOrderStore.reopenInTicket(salesOrder.Id, location, targetId),
	});
});
